import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const DropdownChevronIcon = React.memo(function Cross3Icon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={0.4}
      {...props}
    >
      <path
        d="M1 6L4.5 9.5L8 6"
        stroke={color}
        strokeWidth="1.5"
        // strokeLinecap="round"
        // strokeLinejoin="round"
      />
    </svg>
  );
});

export const ChevronDownIcon2 = React.memo(function ChevronDownIcon2({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4 6L7.5 9.5L11 6" stroke={color} strokeWidth="1.5" />
    </svg>
  );
});

export const ChevronRightIcon2 = React.memo(function ChevronRightIcon2({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M6 4L9.5 7.5L6 11" stroke={color} strokeWidth="1.5" />
    </svg>
  );
});
